import React from "react";
import useSmallNav from "../../../../hooks/useSmallNav";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import golf from "../../../../assets/info/golf-hero.jpg";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoHeader from "../../../atoms/info/InfoHeader/InfoHeader";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import part1 from "../../../../assets/info/vw-golf/golf-mk-5-suspension.jpg";
import InfoFooter from "../../../organisms/InfoFooter/InfoFooter";
import styled from "styled-components";
import { popularVehicle } from "../../../../vars/popularVehicles";

const VWGolf = () => {
  useSmallNav("Volkswagen Golf");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader text={"Volkswagen Golf"} bolder />
        <InfoHero image={golf} />
        <InfoGrid>
          <div>
            <InfoHeader
              text={
                "Firma Pedders z przyjemnością ogłasza, że wprowadziła zawieszenie SportsRyder Ezifit do VW Golf mk5 i 6."
              }
            />
            <InfoHeader
              size="smaller"
              text={
                "Chcesz obniżyć swój samochód, poprawić wygląd i prowadzenie ale nadal chcę zachować przyzwoity poziom komfortu? Obawiasz się, że gwinty będą zbyt trudne?"
              }
            />
            <p>
              W takim razie zestaw Pedders SportsRyder Ezifit jest właściwym
              wyborem dla Ciebie.
            </p>
            <p>
              Zestaw ten zawiera ulepszone amortyzatory ze zmienionym
              współczynnikiem tłumienia dla lepszej kontroli, aby pasowały do
              sprężyn śrubowych Pedders SportsRyder. Zestaw ten jest wyposażony
              w całkowicie zmontowane przednie kolumny, dzięki czemu montaż jest
              jeszcze bardziej „Ezi”. Obniżony wygląd i świetne prowadzenie w
              atrakcyjnej cenie - wszystko w wstępnie zmontowanym zestawie
              EziFit.
            </p>
            <InfoHeader size="smaller" text={"Kluczowe cechy:"} />
            <p>
              Zestaw zawieszenia Pedders SportsRyder EziFit to idealna
              alternatywa dla kupowania oddzielnych komponentów lub łączników
              gwintowanych, gdy chcesz obniżyć swojego Golfa.
            </p>
            <p>
              Krótszy czas instalacji i przyzwoita równowaga między prowadzeniem
              auta a komfortem to kluczowe korzyści wynikające ze stosowania
              zestawu Pedders EziFit, ponieważ sprężyny, amortyzatory i
              mocowania są dostarczane w stanie wstępnie zmontowanym i gotowym
              do montażu. Nie ma potrzeby używania ściągacza do sprężyn,
              ponieważ praca została już wykonana za Ciebie! Po prostu odkręć
              stare i przykręć nowe zawieszenie - PLUG & PLAY w najlepszym
              wydaniu!
            </p>
            <ul>
              <li>
                Wstępnie zmontowany zestaw elementów zawieszenia, w tym
                amortyzatory gazowe Pedders SportsRyder, obniżone sprężyny
                śrubowe Pedders SportsRyder, odboje, zestawy osłon i mocowanie
                przedniego amortyzatora.
              </li>
              <li>
                Krótszy czas instalacji, ponieważ komponenty są dostarczane w
                stanie wstępnie zmontowanym i gotowym do bezpośredniego montażu.
              </li>
              <li>
                Indywidualnie testowany na hamowni jako kompletny system
                zawieszenia współpracujący z fabrycznymi punktami mocowania.
                sprzęt zapewniający jakość i wydajność.
              </li>
              <li>
                Pedders EziFit obniży Twojego Golfa nawet o 35 mm, w zależności
                od modelu. 2 Golfy pokazane na zdjęciach są wyposażone w zestaw
                Pedders SportsRyder Ezifit.
              </li>
              <li>
                Amortyzatory gazowe Pedders SportsRyder w zestawie EziFit są
                wykonane w technologii dwururowej konstrukcji gazowej o dużej
                wytrzymałości i wzmocnionych, podwójnie spawanych mocowaniach
                zapewniających długoterminową trwałość.
              </li>
              <li>
                Kompletny zestaw to system zaprojektowany i wyposażony by
                doświadczyć dynamicznej, sportowej jazdy i niesamowitej
                przyczepności, które nadają się do codziennej jazdy, a także do
                jazdy wyczynowej w trudnych warunkach jezdnych.
              </li>
              <li>Wszystko objęte naszą 2-letnią gwarancją / 40 000 km.</li>
            </ul>
          </div>
          <div>
            {popularVehicle
              .find((e) => e.make === "Volkswagen")
              .models.find((e) => e.display === "Golf")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
            <Gray>
              <InfoHeader
                size="smaller"
                text={"Zestawy zawieszenia Golf MK5 SportsRyder Ezifit"}
              />
              <div>
                <StyledImgParts
                  src={part1}
                  alt="Zestawy zawieszenia Golf MK5 SportsRyder Ezifit"
                />
              </div>
            </Gray>
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/_GNsgVAQwiA"
              title={"VW Golf Video 1"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/wzDv0cCzXXQ"
              title={"VW Golf Video 2"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/g1aSCo4S2_E"
              title={"VW Golf Video 3"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </InfoGrid>
        <InfoFooter make="Volkswagen" model="Golf" />
      </Container>
    </section>
  );
};

export default VWGolf;

const StyledImgParts = styled.img`
  width: 100%;
`;

const Gray = styled.div`
  padding: 25px;
  border-radius: 5px;
  background-color: #f4f4f4;
  margin: 30px 0;
`;
